
const baseGeneralUrl = "General"
const baseUserlUrl = "User"

  const endpoints = {
   getMenuItems:`${baseGeneralUrl}/GetMenu`,
   getSearchSuggestion:`${baseGeneralUrl}/SearchSuggestion`,
   getUserLastSearch:`${baseUserlUrl}/GetUserLastSearched`,
   
   
  };
  
  export default endpoints;